export { default } from "./AccordionDetails.js";
export { default as accordionDetailsClasses } from "./accordionDetailsClasses.js";
export * from "./accordionDetailsClasses.js";